import Button from "@Generic/buttons/Button";

interface AddAdditionalServiceButtonProps {
    closeAndUpdate: () => void,
    cta: string,
    total: string,
}

/**
 * used for adding addons and amenities to ticket
 */
function AddSelectedAmenities(props: AddAdditionalServiceButtonProps) {
    const {
        closeAndUpdate,
        cta,
        total,
    } = props

    return (
        <Button
            onClick={closeAndUpdate}
            className="blue"
            additionalClasses="ticket-amenities__submit"
        >
            {`${cta} ${total}`}
        </Button>
    )
}

export default AddSelectedAmenities